import { Button, Input } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import InputField from "~components/Form/components/InputField";
import Select from "~components/Form/components/Select";
import Modal from "~components/Modal";

const FunnelProductsUpdateModal = ({ isOpen, setIsOpen, submitHandler }) => {
  return (
    <Modal
      isOpen={isOpen}
      className="!p-8"
      onClose={() => {
        setIsOpen(false);
      }}
      hideButtonTwo={true}
      hideButtonOne={true}
      sub={<Content submitHandler={submitHandler} />}
    />
  );
};

const Content = ({ submitHandler }) => {
  return (
    <div>
      <Formik onSubmit={submitHandler} initialValues={{}}>
        {({ errors, touched, setFieldValue, setFieldTouched, isSubmitting }) => (
          <Form class="text-left">
            <h2 className="font-bold text-xl text-center mx-auto max-w-[300px] mb-2">
              Deseja atualizar <br />
              data de negociação?
            </h2>

            <label className="flex text-left items-center justify-center">
              <p className="whitespace-nowrap mr-3">Data de Negociação:</p>
              <div className="max-w-[250px]">
                <InputField
                  inputName="dataNegociacao"
                  inputMask="offmask"
                  inputType="date"
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  defaultValue={"2024-11-03"}
                  isRequired={false}
                />
              </div>
            </label>

            <hr className="my-6" />

            <h2 className="font-bold text-xl text-center mx-auto max-w-[300px] mb-2">
              Ou deseja atualizar <br />
              o status da negociação:
            </h2>

            <Select
              inputName="status"
              className="w-full"
              placeholder="Status"
              options={[
                { label: "Cliente ainda não sabe o SKU", value: 1 },
                { label: "Cliente ainda não sabe o SKU", value: 1 },
                { label: "Cliente ainda não sabe o SKU", value: 1 },
              ]}
            />

            <hr className="my-6" />

            <h2 className="font-bold text-xl text-center mx-auto max-w-[300px] mb-2">
              Insira um motivo de perda:
            </h2>

            <Select
              inputName="motivo"
              className="w-full"
              placeholder="Motivo de Perda"
              options={[
                { label: "Relacionamento com o cliente", value: 1 },
                { label: "Relacionamento com o cliente", value: 1 },
                { label: "Relacionamento com o cliente", value: 1 }
              ]}
            />

            <button type="submit" className="block bg-secundaria text-primaria px-8 py-3 rounded font-bold ml-auto">
              OK
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default FunnelProductsUpdateModal;
